const animationHomeAboutEffect = () => {
	const container = document.querySelector('.about-container');

	if (container) {
		const title = container.querySelector('.about-title'),
			content = container.querySelectorAll('.about-description p');

		const tl = gsap.timeline({
			defaults: {
				duration: 0.3,
				ease: 'power2.out',
			},
			scrollTrigger: {
				trigger: container,
				once: true,
			},
		});

		tl.from(container, { duration: 0.6, xPercent: -100 })
			.from(title, { autoAlpha: 0, y: +40 })
			.from(content, { autoAlpha: 0, y: +40, stagger: 0.2 });

		const picture = container.querySelector('.featured-image'),
			button = container.querySelector('.button');

		const tl2 = gsap.timeline({
			defaults: {
				ease: 'none',
			},
			scrollTrigger: {
				trigger: picture,
				once: true,
			},
		});

		tl2.from(picture, {
			duration: 0.4,
			delay: 0.45,
			autoAlpha: 0,
			x: +20,
		}).from(button, { duration: 0.35, autoAlpha: 0, x: +150 });
	}
};

export default animationHomeAboutEffect;
